import { map, tap } from 'rxjs/operators';
import { ApiService } from '../API/api.service';
import { Injectable } from '@angular/core';
import { Observable, OperatorFunction } from 'rxjs';
import { CommentArray, CommentFilterModel, CommentModel, newCommentModel } from 'src/app/models/Comment.model';
import { DatePipe } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class CommentService {
  constructor(
    private api: ApiService,
    private datePipe: DatePipe,
  ) {}

  newsUrl = 'news/api/v1/';

  getAllComments(filter: CommentFilterModel): Observable<any[]> {
    return this.api.get(`${this.newsUrl}Comments`, filter).pipe(
      map((comments: any) =>
        comments.comments.map((c: CommentModel) => {
          try {
            if (c.commentDate) c.commentDate = new Date(c.commentDate);
          } catch {}
          return c;
        }),
      ),
    );
  }

  getComment(id: string): Observable<CommentModel> {
    return this.api.get(`${this.newsUrl}Comment/${id}`).pipe(map(comment => new CommentModel(comment)));
  }

  postComment(comment: newCommentModel): Observable<CommentModel> {
    return this.api.post(`${this.newsUrl}Comments`, comment, undefined).pipe(map(comment => new CommentModel(comment)));
  }

  editComment(comment: CommentModel): Observable<any> {
    return this.api.put(`${this.newsUrl}Comments/${comment.id}`, comment);
  }

  deleteComment(id: string): Observable<any> {
    return this.api.delete(`${this.newsUrl}Comments/${id}`);
  }

  reportComment(id: string): Observable<any> {
    return this.api.post(`${this.newsUrl}Comments/report`, { newsCommentId: id });
  }
}
